module.exports = __webpack_public_path__ + "img/huochepiao1.fcf54e0b.png";